<div class="photo-grid">
  <div class="photo-item" *ngFor="let item of items">
    <!-- Render as a link if item.link is present -->
    <a *ngIf="item.link" [href]="item.link">
      <img class="photo-image" [src]="item.image" [alt]="item.heading" />
      <div class="overlay">
        <div class="text">
          <h4 class="subheading">{{ item.subheading }}</h4>
          <h3 class="heading">{{ item.heading }}</h3>
        </div>
      </div>
    </a>
    <!-- Render as a simple container if item.link is not present -->
    <div *ngIf="!item.link">
      <img class="photo-image" [src]="item.image" [alt]="item.heading" />
      <div class="overlay">
        <div class="text">
          <h4 class="subheading">{{ item.subheading }}</h4>
          <h3 class="heading">{{ item.heading }}</h3>
        </div>
      </div>
    </div>
  </div>
</div>

